import React from "react";
import "react-quill/dist/quill.snow.css"; // For snow theme
import "react-quill/dist/quill.bubble.css"; // For bubble theme (if used)

const Quiltext = ({ description }) => {
  return (
    <div
      className="ql-editor !p-0 !m-0 !overflow-visible font-CanelaDeck"
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};

export default Quiltext;
